import React from "react";
import { Table } from "../../../ui/components/Table";

interface TableSkeletonRowsProps {
  rowCount?: number;
  columnCount: number;
}

const SKELETON_FADE_KEYFRAMES = `
@keyframes skeletonFade {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
`;

const TableSkeletonRows: React.FC<TableSkeletonRowsProps> = ({
  rowCount = 5,
  columnCount,
}) => {
  const skeletonStyle: React.CSSProperties = {
    backgroundImage:
      "linear-gradient(90deg, rgba(255,255,255,0.4) 0%, rgba(229,231,235,0.8) 50%, rgba(255,255,255,0.4) 100%)",
    backgroundSize: "200% 100%",
    animation: "skeletonFade 1.6s ease-in-out infinite",
  };

  return (
    <>
      <style>{SKELETON_FADE_KEYFRAMES}</style>
      {Array.from({ length: rowCount }).map((_, rowIndex) => (
        <Table.Row key={`skeleton-row-${rowIndex}`}>
          {Array.from({ length: columnCount }).map((_, columnIndex) => (
            <Table.Cell
              key={`skeleton-cell-${rowIndex}-${columnIndex}`}
              className="py-3"
            >
              <div
                className="h-4 w-full rounded bg-neutral-100"
                style={skeletonStyle}
              />
            </Table.Cell>
          ))}
        </Table.Row>
      ))}
    </>
  );
};

export default TableSkeletonRows;

